// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3G66w","actions":"GroupTable_actions__1KkNN","deleteModalFooter":"GroupTable_deleteModalFooter__3SNzt"};